import React, { useEffect, useState } from "react";
import { getVideoThumbnail } from "../../utils/videoThumbs";

function VideoThumb({ url, seekSec = 0.1, className, title, onFail }) {
  const [dataUrl, setDataUrl] = useState(undefined); // undefined = loading, null = capture failed
  useEffect(() => {
    let cancelled = false;
    setDataUrl(undefined);
    getVideoThumbnail(url, seekSec).then((res) => {
      if (!cancelled) setDataUrl(res);
    });
    return () => {
      cancelled = true;
    };
  }, [url, seekSec]);

  if (typeof dataUrl === "string") {
    return <img className={className} src={dataUrl} alt="" title={title} />;
  }
  if (dataUrl === null) {
    return (
      <video
        className={className}
        src={`${url}#t=${seekSec}`}
        title={title}
        muted
        playsInline
        preload="auto"
        onError={onFail}
      />
    );
  }
  return <div className={`${className || ""} it-video-thumb-loading`.trim()} title={title} />;
}

export default VideoThumb;
